import { useQuery } from '@tanstack/react-query';
import { getExercisesByBodyPart, searchExercises } from '../services/exercisedb';

export function useExercisesByBodyPart(bodyPart, limit = 20) {
  return useQuery({
    queryKey: ['exercises', 'bodyPart', bodyPart, limit],
    queryFn: () => getExercisesByBodyPart(bodyPart, limit),
    staleTime: 1000 * 60 * 60,
    enabled: !!bodyPart,
  });
}

export function useExerciseSearch(query) {
  return useQuery({
    queryKey: ['exercises', 'search', query],
    queryFn: () => searchExercises(query, 20),
    staleTime: 1000 * 60 * 60,
    enabled: query?.length > 2,
  });
}
